module.exports = __webpack_public_path__ + "img/Group 651.b79399c8.png";